import { Stack, useBreakpointValue, FormControl, FormLabel, HStack, IconButton, Select, FormErrorMessage, Input, Tooltip } from '@chakra-ui/react'
import * as React from 'react'


import { IApiSafetyChecklistCreateRequest } from '../../../models/api/safetychecklist/IApiSafetyChecklistCreateRequest';
import { IBaseDrawerProps } from '../BaseDrawer';
import { Field, FieldProps, FormikProps, validateYupSchema } from 'formik';
import { BaseDrawerWithForm } from '../BaseDrawerWithForm';
import { InputFormControl } from '../../formcontrols/InputFormControl';
import { SafetyChecklistEditor } from '../../SafetyChecklistEditor/SafetyChecklistEditor';
import { IApiProjectOptionParty } from '../../../models/api/project/options/IApiProjectOptionParty';
import { ContactSearch } from '../../ContactSearch/ContactSearch';
import { ContactSearchResult } from '../../ContactSearch/ContactSearchResult';
import { FiCheck, FiEdit2, FiSquare, FiX } from 'react-icons/fi';
import { IApiTradeResponse } from '../../../models/api/trade/IApiTradeResponse';
import { boolToString, ProjectPartyDocumentState, stringToBool } from '../../../pages/project-parties/ProjectParties';
import { RadioIconButtonGroup, RadioIconButton } from '../../RadioIconButtonGroup/RadioIconButtonGroup';
import { Autocomplete } from '../../Autocomplete/Autocomplete';
import { IApiContactResponse } from '../../../models/api/contact/IApiContactResponse';
import { AutocompleteContactResult } from '../../Autocomplete/AutocompleteContactResult';
import { AutocompleteTradeResult } from '../../Autocomplete/AutocompleteTradeResult';

export interface IEditPartyDrawerProps extends Omit<IBaseDrawerProps<IApiProjectOptionParty>, "defaultValue" | "submitAllowed" | "children" | "saveText" | "discardText" | "headerText" | "isOpen"> {
    defaultValue: IApiProjectOptionParty | undefined;
}

export const EditPartyDrawer = (props: IEditPartyDrawerProps) => {
    return (
        <BaseDrawerWithForm
            isOpen={props.defaultValue !== undefined}
            onSubmit={props.onSubmit}
            onDiscard={props.onDiscard}
            defaultValues={props.defaultValue}
            headerText="Beteiligte(n) bearbeiten"
        >
            {({ handleSubmit, errors, touched, isSubmitting, setFieldValue, values }: FormikProps<IApiProjectOptionParty>) => (
                <Stack px="0" spacing="4">
                    <FormControl>
                        <FormLabel htmlFor="contact">Kontakt</FormLabel>
                        <Field name="contact" validate={(value: any) => (value === undefined) ? "Kontakt ist erforderlich!" : undefined}>
                            {({ meta: { value } }: FieldProps) => (
                                <AutocompleteContactResult contact={value} />
                            )}
                        </Field>                   
                    </FormControl>
                    <FormControl isInvalid={(errors.trade && touched.trade) ? true : false}>
                        <FormLabel htmlFor="trade">Gewerk</FormLabel>
                        <Field name="trade" validate={(value: string) => (value !== undefined) ? undefined : "Gewerk ist erforderlich!"}>
                            {({ meta: { value } }: FieldProps) => (
                                <AutocompleteTradeResult trade={value} />
                            )}
                        </Field>
                    </FormControl>
                    <FormControl>
                        <FormLabel htmlFor="startDate">Arbeitsbeginn</FormLabel>
                        <Field 
                            as={Input}
                            id="startDate"
                            name="startDate"
                            variant="outline"
                            type='date'
                            size='md'
                            maxLength={10}
                            //validate={(value: string) => (value && value.length === 10) ? undefined : "Arbeitsbeginn ist erforderlich!"}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Dokumente</FormLabel>
                        <HStack spacing="5" mt={2}>
                            <RadioIconButtonGroup key="aba" defaultValue={boolToString(values.aba)} size="sm" onChange={(value) => setFieldValue("aba", stringToBool(value), false)}>
                                <RadioIconButton value="true" aria-label="true" icon={<FiCheck fontSize="1.25rem" />} _checked={{ bg: 'green.200' }} />
                                <RadioIconButton value="false" aria-label="false" icon={<FiX fontSize="1.25rem" />} _checked={{ bg: 'red.200' }} />
                                <RadioIconButton value="null" aria-label="null" icon={<FiSquare fontSize="1.25rem" />} />
                            </RadioIconButtonGroup>
                            <FormLabel fontSize="sm" >Arbeitsbeginnanzeige (ABA)</FormLabel>
                        </HStack>
                        <HStack spacing="5" mt={2}>
                            <RadioIconButtonGroup key="uwn" defaultValue={boolToString(values.uwn)} size="sm" onChange={(value) => setFieldValue("uwn", stringToBool(value), false)}>
                                <RadioIconButton value="true" aria-label="true" icon={<FiCheck fontSize="1.25rem" />} _checked={{ bg: 'green.200' }} />
                                <RadioIconButton value="false" aria-label="false" icon={<FiX fontSize="1.25rem" />} _checked={{ bg: 'red.200' }} />
                                <RadioIconButton value="null" aria-label="null" icon={<FiSquare fontSize="1.25rem" />} />
                            </RadioIconButtonGroup>
                            <FormLabel fontSize="sm" >Unterweisungsnachweis (UWN)</FormLabel>
                        </HStack>
                        <HStack spacing="5" mt={2}>
                            <RadioIconButtonGroup key="bev" defaultValue={boolToString(values.bev)} size="sm" onChange={(value) => setFieldValue("bev", stringToBool(value), false)}>
                                <RadioIconButton value="true" aria-label="true" icon={<FiCheck fontSize="1.25rem" />} _checked={{ bg: 'green.200' }} />
                                <RadioIconButton value="false" aria-label="false" icon={<FiX fontSize="1.25rem" />} _checked={{ bg: 'red.200' }} />
                                <RadioIconButton value="null" aria-label="null" icon={<FiSquare fontSize="1.25rem" />} />
                            </RadioIconButtonGroup>
                            <FormLabel fontSize="sm" >Baustellenevaluierung (BEV)</FormLabel>
                        </HStack>
                    </FormControl>
                </Stack>
            )}
        </BaseDrawerWithForm>
    );
}